export default "__VITE_ASSET__AI3mdqtvk84BhY7PMwLokA__"